<mat-card-header>
  <mat-card-title [hidden]="!title.hasChildNodes()">
    <h1 mat-dialog-title #title>
      <ng-content select="app-dialog-title, [app-dialog-title], [appDialogTitle]"></ng-content>
    </h1>
  </mat-card-title>
  <mat-card-subtitle [hidden]="!subtitle.hasChildNodes()" #subtitle>
    <ng-content
      select="app-dialog-subtitle, [app-dialog-subtitle], [appDialogSubtitle]"
    ></ng-content>
  </mat-card-subtitle>
  <div
    class="app-dialog-header-buttons-container flex-vertical-center"
    [hidden]="!headerButtons.hasChildNodes()"
    #headerButtons
  >
    <ng-content
      select="app-dialog-header-button, [app-dialog-header-button], [appDialogHeaderButton]"
    ></ng-content>
  </div>
</mat-card-header>
<mat-card-content>
  @if (showInnerCard) {
    <mat-card appearance="raised" class="inner-card">
      <ng-container *ngTemplateOutlet="contentTpl"></ng-container>
    </mat-card>
  } @else {
    <ng-container *ngTemplateOutlet="contentTpl"></ng-container>
  }
  <ng-template #contentTpl>
    <ng-content></ng-content>
  </ng-template>
</mat-card-content>
<mat-card-actions>
  <ng-content
    select="app-dialog-action-button, [app-dialog-action-button], [appDialogActionButton], app-dialog-action-button-custom, [app-dialog-action-button-custom], [appDialogActionButtonCustom]"
  ></ng-content>
</mat-card-actions>
